import './ErrorsList.scss';

import React from 'react';

import ListToggle from '../../../../../../../common/ListToggle';
import { ToggleType } from '../../../../../../../common/ListToggle/ListToggle';
import bem from '../../../../../../../utils/bem';
import type { ErrorItem } from '../../../types';
import { getErrorHeader } from './utils';

type Props = {
  errorItems: ErrorItem[];
};

const [block, element] = bem('scrollable-list');

const ErrorsList = ({ errorItems }: Props): JSX.Element => {
  return (
    <div className={block()}>
      {errorItems.map((error) => {
        return (
          <ListToggle
            ignoreInitialExpanded={true}
            header={
              <>
                <div className={element('list-header')}>{getErrorHeader(error)}</div>
                <div className={element('list-header-description')}>{error.message}</div>
              </>
            }
            key={error.message}
            type={ToggleType.SolidGray}
          >
            <ul>
              {error.itemIds.map((itemId) => (
                <li className={element('list-item')} key={itemId}>
                  {itemId}
                </li>
              ))}
            </ul>
          </ListToggle>
        );
      })}
    </div>
  );
};

export default ErrorsList;
